import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import "./collapsibleSection.scss";

const CollapsibleSection = ({ title, children, isOpen, onToggle, badge }) => {
    return (
        <div className={`collapsible-section ${isOpen ? "open" : ""}`}>
            <div className="section-header" onClick={onToggle}>
                <div className="section-title-wrap">
                    <h3 className="section-title">{title}</h3>
                    {badge && <span className="section-badge">{badge}</span>}
                </div>
                <button className="toggle-button" aria-label={isOpen ? "접기" : "펼치기"}>
                    <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
                </button>
            </div>
            {isOpen && <div className="section-content">{children}</div>}
        </div>
    );
};

export default CollapsibleSection;
